import React from 'react'
import { Badge } from './styled'

export default () => {
    return(
        <>
            <Badge className='bg-danger mx-1'/>
        </>
    )
}